import { BaseError } from './BaseError.js';
/**
 * Error thrown when validation fails.
 * Used for input validation, schema validation, business rule violations, etc.
 */
export class ValidationError extends BaseError {
    field;
    name;
    constructor(message, field, cause, name = 'ValidationError') {
        super(message, cause);
        this.field = field;
        this.name = name;
    }
}
//# sourceMappingURL=ValidationError.js.map